<template>
  <div class="lower-limb-orthosis-step-three-a">
    <div class="content">
      <div class="img-container">
        <img src="@/assets/img/schema_omi_3a.svg">
        <v-text-field
          v-model="form.schematic_short_right_a"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Courte) A Droite"
          :class="{ error: errors.has('(Schéma Courte) A Droite') }"
          outlined
          type="number"
          label="mm"
          style="top: 16.6%;left: 9.1%;"
          height="100%"
        />
        <v-text-field
          v-model="form.schematic_short_right_b"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Courte) B Droite"
          :class="{ error: errors.has('(Schéma Courte) B Droite') }"
          outlined
          type="number"
          label="mm"
          style="top: 43.6%;left: 11.9%;"
          height="100%"
        />
        <v-text-field
          v-model="form.schematic_short_right_c"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Courte) C Droite"
          :class="{ error: errors.has('(Schéma Courte) C Droite') }"
          outlined
          type="number"
          label="mm"
          style="top: 50.2%;left: 11.9%;"
          height="100%"
        />
        <v-text-field
          v-model="form.schematic_short_right_d"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Courte) D Droite"
          :class="{ error: errors.has('(Schéma Courte) D Droite') }"
          outlined
          type="number"
          label="mm"
          style="top: 62.4%;left: 9.1%;"
          height="100%"
        />
        <v-text-field
          v-model="form.schematic_short_right_e"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Courte) E Droite"
          :class="{ error: errors.has('(Schéma Courte) E Droite') }"
          outlined
          type="number"
          label="mm"
          style="top: 64.4%;left: 22.9%;"
          height="100%"
        />
        <v-text-field
          v-model="form.schematic_short_right_f"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Courte) F Droite"
          :class="{ error: errors.has('(Schéma Courte) F Droite') }"
          outlined
          type="number"
          label="mm"
          style="top: 72.4%;left: 34.8%;"
          height="100%"
        />
        <v-text-field
          v-model="form.schematic_short_g"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Courte) G Droite"
          :class="{ error: errors.has('(Schéma Courte) G Droite') }"
          outlined
          type="number"
          label="mm"
          style="top: 33.1%;left: 0%;"
          height="100%"
        />
        <v-text-field
          v-model="form.schematic_short_left_a"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Courte) A Gauche"
          :class="{ error: errors.has('(Schéma Courte) A Gauche') }"
          outlined
          type="number"
          label="mm"
          style="top: 39.5%;left: 82.4%;"
          height="100%"
        />
        <v-text-field
          v-model="form.schematic_short_left_b"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Courte) B Gauche"
          :class="{ error: errors.has('(Schéma Courte) B Gauche') }"
          outlined
          type="number"
          label="mm"
          style="top: 66.5%;left: 79.5%;"
          height="100%"
        />
        <v-text-field
          v-model="form.schematic_short_left_c"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Courte) C Gauche"
          :class="{ error: errors.has('(Schéma Courte) C Gauche') }"
          outlined
          type="number"
          label="mm"
          style="top: 73%;left: 79.5%;"
          height="100%"
        />
        <v-text-field
          v-model="form.schematic_short_left_d"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Courte) D Gauche"
          :class="{ error: errors.has('(Schéma Courte) D Gauche') }"
          outlined
          type="number"
          label="mm"
          style="top: 85.3%;left: 82.3%;"
          height="100%"
        />
        <v-text-field
          v-model="form.schematic_short_left_e"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Courte) E Gauche"
          :class="{ error: errors.has('(Schéma Courte) E Gauche') }"
          outlined
          type="number"
          label="mm"
          style="top: 87.3%;left: 67%;"
          height="100%"
        />
        <v-text-field
          v-model="form.schematic_short_left_f"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Courte) F Gauche"
          :class="{ error: errors.has('(Schéma Courte) F Gauche') }"
          outlined
          type="number"
          label="mm"
          style="top: 95.1%;left: 57.8%;"
          height="100%"
        />
        <v-text-field
          v-model="form.schematic_short_left_g"
          v-validate="'numeric|max:4'"
          data-vv-name="(Schéma Courte) G Gauche"
          :class="{ error: errors.has('(Schéma Courte) G Gauche') }"
          outlined
          type="number"
          label="mm"
          style="top: 56.4%;left: 92.2%;"
          height="100%"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LowerLimbOrthosisStepThreeA",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  created() {
    this.$validator = this.parentValidator;
  }
};
</script>

<style lang="scss">
.lower-limb-orthosis-step-three-a {
  .content {
    display: flex;
    min-height: 80vh;
    .img-container {
      position: relative;
      display: inline-block;
      margin: auto;
      img {
        height: 100%;
        width: 100%;
        min-width: 800px;
        @media (max-width: 800px) {
          min-width: auto;
        }
      }
      .v-input {
        position: absolute;
        width: 7.9%;
        height: 5.1%;
        @media (max-width: 800px) {
          height: 4%;
        }
        .v-input__control {
          height: 100%;
          .v-input__slot {
            min-height: auto;
          }
        }
      }
    }
  }
}
</style>
